// The campaign ends at midnight Paris time, including in an already-open tab.
const end = Date.parse('2026-10-19T00:00:00+02:00');
const expire = () => {
  if (Date.now() < end) return;
  document.querySelectorAll('[data-so-autumn]').forEach(element => { element.hidden = true; });
  document.querySelectorAll('[data-so-autumn-fallback]').forEach(element => { element.hidden = false; });
};
expire();
const remaining = end - Date.now();
if (remaining > 0) setTimeout(expire, Math.min(remaining + 1000, 2147483647));
document.addEventListener('visibilitychange', expire);
